'use client'

import { BundleSummaryModel } from '@marketplace-web/bundles/items-bundle-data'
import { ProductItemModel } from '@marketplace-web/item-box/product-item-data'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import ServiceFeeIncludedTitle from '../../ServiceFeeIncludedTitle'
import DetailedPriceBreakdown from './DetailedPriceBreakdown'

type Props = {
  isSellerBusiness: boolean
  bundleSummary: BundleSummaryModel
  selectedItems: Array<ProductItemModel>
  escrowNoteTranslationKey?: string
}

const BundleFooterPriceBreakdown = ({
  bundleSummary,
  isSellerBusiness,
  selectedItems,
  escrowNoteTranslationKey,
}: Props) => {
  const { price, buyerProtectionFee, priceWithBuyerProtectionFee } = bundleSummary
  const selectedItemIds = selectedItems.map(({ id }) => id)
  const unifiedPriceBreakDownTest = useAbTest('unified_price_breakdown_v2')
  const shouldShowDetailedBreakdown = unifiedPriceBreakDownTest?.variant === 'on'

  if (shouldShowDetailedBreakdown) {
    return (
      <DetailedPriceBreakdown
        bundleSummary={bundleSummary}
        isSellerBusiness={isSellerBusiness}
        selectedItems={selectedItems}
        escrowNoteTranslationKey={escrowNoteTranslationKey}
      />
    )
  }

  return (
    <ServiceFeeIncludedTitle
      itemId={selectedItemIds[0]!}
      isSellerBusiness={isSellerBusiness}
      shouldTrimTitle
      shouldMinimiseTitle
      itemPrice={price}
      serviceFee={buyerProtectionFee}
      totalItemPrice={priceWithBuyerProtectionFee}
      escrowNoteTranslationKey={escrowNoteTranslationKey}
    />
  )
}

export default BundleFooterPriceBreakdown
